class AjaxCollectionPages extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.loadMoreBtn = this.querySelector('#product-grid-pagination .pagination__load-button');
        this.status = document.querySelector('.pagination__load-status .infinite-scroll-request');
        this.loadingError = document.querySelector('.pagination__load-status .infinite-scroll-error');
        this.rootUrl = this.getAttribute("data-root-url");
        this.paginationTemplate = this.getAttribute('data-pagination-template');
        this.currentPageNumber = this.getAttribute("data-current-page");
        this.nextPageNumber = parseInt(this.currentPageNumber) + 1;
        this.sectionId = this.getAttribute("data-section-id");

        if(this.loadMoreBtn){
            this.loadMoreBtn.addEventListener('click', this.loadMoreProducts.bind(this));
        }
        this.paginationDiv = document.querySelector('#product-grid-pagination');
        this.paginationList = document.querySelector('#product-grid-pagination .pagination__list.list-unstyled');
        this.paginationStatus = document.querySelector('#product-grid-pagination .pagination__status');
    }

    loadMoreProducts(e) {
        e.preventDefault();
        const collectionHandle = this.getAttribute('data-collection-handle');
    
        // const nextPageUrl = `${this.rootUrl}collections/${this.collectionHandle}?view=json-schema&page=${this.nextPageNumber}`;
        let nextPageUrl = this.loadMoreBtn.getAttribute("href");
        if (!nextPageUrl.includes("view=json-schema")){
            nextPageUrl += "&view=json-schema";
        }
    
        this.loadMoreBtn.classList.add('visually-hidden');
        this.status.classList.remove('visually-hidden');
        this.loadingError.classList.add('visually-hidden');
    
        fetch(nextPageUrl)
            .then(response => response.text())
            .then(jsonpage => {
                const parser = new DOMParser();
                const doc = parser.parseFromString(jsonpage, 'text/html');
    
                const productGrid = document.querySelector('#product-grid');
                const rawJson = doc.querySelector('.page-json')?.textContent || '[]';
                const newItemsJson = JSON.parse(rawJson);
                
                if (!newItemsJson.length) throw new Error("No products found.");
    
                const fragment = document.createDocumentFragment();
    
                const newItemsHtml = newItemsJson.map((item) => {
                    if (item && item.gridItem === 'promo' && item.html) {
                        return item.html.trim();
                    }
                    const productJson = item;
                    const markup = window.Shopify.theme.helpers.getProductCardMarkup(
                        productJson,
                        productJson.first_variant,
                        "collection-list"
                    );

                    return `
                        <li id="prod_li_${productJson.handle}" class="grid__item scroll-trigger animate--slide-in" data-cascade>
                            ${markup}
                        </li>`;
                }).join('');
    
                // Append HTML more efficiently
                const tempContainer = document.createElement('div');
                tempContainer.innerHTML = `<ul>${newItemsHtml}</ul>`;
                [...tempContainer.firstChild.children].forEach(li => fragment.appendChild(li));
                productGrid.appendChild(fragment);
    
                this.nextPageNumber++;
    
                // Pagination updates
                const newNextBtn = doc.querySelector('#product-grid-pagination .pagination__load-button');
                this.loadMoreBtn.classList.toggle('visually-hidden', !newNextBtn);
                if (newNextBtn) {
                    const newNextBtnHref = newNextBtn.getAttribute('href').replace(/&view=json-schema/, '').replace(/&view=scrolling-collection/, '');
                    this.loadMoreBtn.setAttribute('href', newNextBtnHref);
                }
    
                let newPaginationList = doc.querySelector('#product-grid-pagination .pagination__list.list-unstyled');

                newPaginationList.querySelectorAll('li').forEach(li => {
                    li.querySelectorAll('a').forEach(a => {
                        a.href = a.href.replace(/&view=json-schema/, '').replace(/&view=scrolling-collection/, '');
                    });
                });

                const newPaginationStatus = doc.querySelector('#product-grid-pagination .pagination__status');
                if (this.paginationList && newPaginationList) {
                    this.paginationList.innerHTML = newPaginationList.innerHTML;
                }
    
                if (this.paginationStatus && newPaginationStatus) {
                    this.paginationStatus.innerHTML = newPaginationStatus.innerHTML;
                }
    
                this.status.classList.add('visually-hidden');
                this.loadingError.classList.add('visually-hidden');
            })
            .catch(error => {
                console.error('Error loading more products:', error);
                this.loadMoreBtn.classList.remove('visually-hidden');
                this.status.classList.add('visually-hidden');
                this.loadingError.innerHTML += `<br>${error.message}`;
                this.loadingError.classList.remove('visually-hidden');
            });
    }
    


}

customElements.define('ajax-collection-pages', AjaxCollectionPages);